export const AMPLITUDE_EVENT_TYPE = {
  EXTERNAL_SERVICE_ERROR: 'External Service Error'
};

export const EXTERNAL_SERVICE = {
  FIRESTORE: 'firestore',
  FIREBASE_STORAGE: 'firebase_storage'
};

export const ANALYTICS_USER_TYPE = {
  BUSINESS: 'business',
  INFLUENCER: 'influencer'
};

export const EXTERNAL_SERVICE_ACTION = {
  CHAT_ROOM_READ: 'chat_room_read',
  CHAT_ROOM_LISTEN: 'chat_room_listen',
  CHAT_ROOM_CREATE: 'chat_room_create',
  CHAT_ROOM_UPDATE: 'chat_room_update',
  CHAT_MESSAGE_SEND: 'chat_message_send',
  CHAT_MESSAGE_UPDATE: 'chat_message_update',
  CHAT_MESSAGES_READ: 'chat_messages_read',
  CHAT_MESSAGES_LISTEN: 'chat_messages_listen',
  CHAT_UNREAD_COUNT_LISTEN: 'chat_unread_count_listen',
  CHAT_FILE_UPLOAD: 'chat_file_upload',
  CHAT_FILE_GET_URL: 'chat_file_get_url'
};
